import React, { useRef, useState } from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import style from './AppMobileFooter.module.scss'
import commonStyle from '../../style.module.scss'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

interface IAppMobileFooterProps {
  openCart: () => void
  closeCart: () => void
  cartNumber: number
  selectedIndex: boolean
  closeItem: () => void
  showHint: () => void
  closeSimulation: () => void
  cartDisabled: boolean
}

const AppMobileFooter = ({
  openCart,
  closeCart,
  cartNumber,
  selectedIndex,
  closeItem,
  showHint,
  closeSimulation,
  cartDisabled
}: IAppMobileFooterProps) => {
  const [changed, setChanged] = useState(0)
  const cachedNumber = useRef(0)
  if (cachedNumber.current < cartNumber) {
    setChanged(changed + 1)
  }
  cachedNumber.current = cartNumber
  return (
    <footer className={style.Footer}>
      <div className={style.FooterIcon} onClick={selectedIndex ? closeItem : closeCart}>
        <div className={`${style.IconPlace} ${style.Home}`}></div>
      </div>
      <div className={style.FooterIcon}>
        <EmptyLink>
          <div className={`${style.IconPlace} ${style.Video}`}></div>
        </EmptyLink>
      </div>
      <div className={style.FooterIcon}>
        <EmptyLink>
          <div className={`${style.IconPlace} ${style.Profile}`}></div>
        </EmptyLink>
      </div>
      {cartDisabled ? (
        <div className={style.FooterIcon}>
          <EmptyLink>
            <div className={`${style.IconPlace} ${style.Cart}`}>
              <span className={cartNumber > 99 ? style.CartCompact : style.CartDefault}>
                {cartNumber > 99 ? '99+' : cartNumber}
              </span>
            </div>
          </EmptyLink>
        </div>
      ) : (
        <div className={`${style.FooterIcon} ${style.Animation}`} onClick={openCart}>
          <TransitionGroup>
            <CSSTransition key={changed} timeout={400}>
              <div className={`${style.IconPlace} ${style.Cart}`}>
                <span className={cartNumber > 99 ? style.CartCompact : style.CartDefault}>
                  {cartNumber > 99 ? '99+' : cartNumber}
                </span>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
      )}
      <div className={style.FooterIcon}>
        <div className={`${style.IconPlace} ${commonStyle.IconAytmPlace}`}>
          <i className="icon-aytmfd-help" onClick={showHint} />
        </div>
        {/* <EmptyLink>
          <div className={`${style.IconPlace} ${style.Menu}`}></div>
        </EmptyLink> */}
      </div>
      <div className={style.FooterIcon}>
        <div className={`${style.IconPlace} ${commonStyle.IconAytmPlace}`}>
          <i className=" icon-aytmfd-exit" onClick={closeSimulation} />
        </div>
        {/* <EmptyLink>
          <div className={`${style.IconPlace} ${style.Chat}`}></div>
        </EmptyLink> */}
      </div>
    </footer>
  )
}

export default AppMobileFooter
